import { updateShareContact as updateContact } from '@/api/passenger'

const updateShareContact = (context, params) => {
  return updateContact(params).then((response) => {
    return response
  })
}

export default {
  updateShareContact
}
